import { useCallback, useState } from "react";
import Popup from "../../../components/Popup";
import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import Book4Time from "../../../assets/img/SolutionsIcons/AgilysysBook4Time.svg";
import { Header } from "../../../components/Header";

const Book4TimeFPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const [showVideo, setShowVideo] = useState<boolean>(false);
    return(
        <div className="page splash book4timePage">
            <div className="page-title"><img src={Book4Time} alt=""/></div>
            <Header />
            <div className="text-blocks">
                <div className="std-text">
                    Drive Spa revenue while delivering a 5-Star resident 
                    experience with a solution built to make life easier and 
                    integrate with your existing Agilysys systems. Book 
                    appointments, set-up loyalty rewards and manage 
                    inventory across multiple locations.{'\n\n'}
                </div>
            </div>
            <div className="play-video" onClick={()=>{
                _logEvent('click', "Solutions - Book4Time", "Play Video");
                addFlow("Play Video");
                setShowVideo(true)
                }}>
                <PlayTriangle />
                Play Video
            </div>
            <img className="img-1" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/book4time1.png"} alt="" />
            <img className="img-2" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/book4time2.png"} alt="" />
            <img className="img-3" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/book4time3.png"} alt="" />
            <Popup showPopup={showVideo} setShowPopup={()=>setShowVideo(false)} disableOffClick={true}>
                <>{showVideo && <video 
                autoPlay
                controls
                src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/Book4time_Feb19_2025.mp4"} />}</>
            </Popup>
        </div>
    )
}

export default Book4TimeFPage;